import { render, staticRenderFns } from "./CampaignToInventoryModal.vue?vue&type=template&id=2c70b745&scoped=true"
import script from "./CampaignToInventoryModal.vue?vue&type=script&lang=js"
export * from "./CampaignToInventoryModal.vue?vue&type=script&lang=js"
import style0 from "./CampaignToInventoryModal.vue?vue&type=style&index=0&id=2c70b745&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c70b745",
  null
  
)

export default component.exports